import { render, staticRenderFns } from "./MainInfo.vue?vue&type=template&id=41839648&scoped=true"
import script from "./MainInfo.vue?vue&type=script&lang=js"
export * from "./MainInfo.vue?vue&type=script&lang=js"
import style0 from "./MainInfo.vue?vue&type=style&index=0&id=41839648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41839648",
  null
  
)

export default component.exports